/**
 * Main scripts, loaded on all pages.
 *
 * @package Zola-Electric
 */

import '../sass/main.scss';

import { WebFont } from './components/fonts';
import { country } from './components/country-dropdown';
import { common } from './components/common';
import { search } from './components/search';
import { slider } from './components/slider';
import AOS from './vendor/aos';

window.$ = window.$ || jQuery;

// Initialize common scripts.
WebFont.init();
search.init();
country.init();
common.init();
slider.init();

// Init AOS.
AOS.init();
